<ng-container *transloco="let t">
  <label for="analysis-weight-selector" class="kxi-text-large">{{
    t('driver-analysis-dialog.weight-step.select-field')
  }}</label>

  <div class="xi-input-field-wrapper">
    <xi-dropdown
      id="analysis-weight-selector"
      label="{{ t('driver-analysis-dialog.weight-step.select-or-next') }}"
      select="single"
      [value]="selectedField"
      [data]="availableFields"
      [stretch]="true"
      [hasPortal]="true"
      [direction]="12"
      (onValueChange)="onWeightChanged($event)"
    >
    </xi-dropdown>
  </div>
</ng-container>
